import React from 'react'
import PaymentLinkActivityListItem from '../PaymentLinkActivityListItem/PaymentLinkActivityListItem'
import type { PaymentLinkActivity } from '../PaymentLinkActivityListItem/PaymentLinkActivityListItem'
import EmptyList from '../EmptyList/EmptyList'
import { Container, EmptyContainer, EmptyText, DividerLine } from './PaymentLinkList.styles'

export type PaymentLinkListProps = {
    activities: PaymentLinkActivity[]
    onItemClick: (activity: PaymentLinkActivity) => void
    emptyText: string
    quotationLabel: string
    currencyText: string
}

const PaymentLinkList = ({
    activities,
    onItemClick,
    emptyText,
    quotationLabel,
    currencyText,
}: PaymentLinkListProps) => {
    return (
        <Container>
            {activities.length === 0 && (
                <EmptyContainer>
                    <EmptyList defaultText="" defaultPressableText="">
                        <EmptyText>
                            {emptyText}
                        </EmptyText>
                    </EmptyList>
                </EmptyContainer>
            )}
            {activities.map((activity, index) => {
                return (
                    <React.Fragment key={index}>
                        <PaymentLinkActivityListItem
                            uuid={activity.uuid}
                            status={activity.status}
                            amount={activity.amount}
                            timestamp={activity.timestamp}
                            onClick={() => onItemClick(activity)}
                            quotationLabel={quotationLabel}
                            currencyText={currencyText}
                        />
                        {index !== activities.length - 1 && <Divider />}
                    </React.Fragment>
                )
            })}
        </Container>
    )
}

export default PaymentLinkList

const Divider = () => {
    return <DividerLine />
}
